import { Component } from '@angular/core';
import { AppConfigService } from '../../services';

/**
 * Not Found Component
 * @export
 * @class NotFoundComponent
 * @typedef {NotFoundComponent}
 */
@Component({
  selector: 'aup-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent {
  logoPath: string;
  pageTitle: string;

  constructor(appConfigService: AppConfigService) {
    const countryConfig = appConfigService.getCountryConfig();
    this.logoPath = countryConfig?.logoPath;
    this.pageTitle = countryConfig?.pageTitle;
  }
}
